import { Component, Prop, Vue } from 'vue-property-decorator';
import { environment } from '@/helpers/Environment';
@Component({})
export default class EventsList extends Vue {
    @Prop({ required: true })
    sessions;
    // TODO: Remove these config options once we have confidence in this in production
    sessionsEnabled = environment.config.my_account_pages?.upcoming_events ?? false;
}
